import API from "../api";
export default {
  namespaced: true,
  state: {
    myInfo: {},
    userAreaIsGarantia: false,
    userAreaIsAgro: false,
    userAreaIsGeral: false,
    userIsGuest: false,
    userIsEmployee: false
  },
  mutations: {
    setMyInfo(state, payload) {
      state.myInfo = payload;
      state.userAreaIsGarantia =
        state.myInfo.area_usuario?.id == "garantia" ||
        state.myInfo.area_usuario?.id == "geral";
      state.userAreaIsAgro = state.myInfo.area_usuario?.id == "agronegocio";
      state.userAreaIsGeral = state.myInfo.area_usuario?.id == "geral";
      state.userIsGuest = state.myInfo.is_guest ?? false;
      state.userIsEmployee = state.myInfo.estrutura?.id == "funcionario";
      state.userId = state.myInfo.Id;
    },
    getMyInfo(state) {
      if (state.myInfo == null) {
        this.requestMyInfo();
      }
      return state.myInfo;
    }
  },
  actions: {
    async requestMyInfo({ commit }) {
      const { data } = await API.getMyInfo();
      commit("setMyInfo", data);
      return data;
    },
    clearMyInfo({ commit }) {
      let data = {};
      commit("setMyInfo", data);
      return data;
    },
    async saveMyInfo({ commit }, payload) {
      const { data } = await API.putMyInfo(payload);
      commit("setMyInfo", data);
      return data;
    },
    async changePassword(_context, payload) {
      const { data } = await API.putChangePassword(payload);
      return data;
    },
    async uploadAvatar(_context, payload) {
      const { data } = await API.postAvatar(payload);
      return data;
    },
    setGuestUserInfo({ commit }, payload) {
      const data = {
        nickname: "Convidado",
        area_usuario: payload ? "garantia" : payload.area,
        is_guest: true,
        group_id: payload ?? payload.group_id
      };
      commit("setMyInfo", data);
    }
  },
  modules: {}
};
